import React, { Component } from 'react'
import styled from 'styled-components'
import Text from '../../components/Text'

const Box = styled.div`
  text-align: center;
  color: var(--red);
  margin: 1.5rem 0;
`

const Icon = styled.div`
  margin-right: 0.5rem;
`

export default class ErrorMessage extends Component {
  render() {
    return (
      <Box>
        <Icon className="fas fa-exclamation-triangle" />
        <Text str="prose.somethingWentWrong" />
      </Box>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Card/ErrorMessage.js